import React, {useContext, useState, useEffect} from "react"
import axios from "axios";
import {SERVER} from "../../Constants.js"
import { StreamChat } from "stream-chat";
import {STREAM_API} from "../../Constants";

const AuthContext = React.createContext()
export function useAuth() {
    return useContext(AuthContext)
}

export function AuthProvider({children}) {
    const [currentUser, setCurrentUser] = useState()
    const [loading, setLoading] = useState(false)
    // Created once; Stream's default 3s request timeout is too short for the admin channel query.
    const [chatClient] = useState(() => new StreamChat(STREAM_API, { timeout: 15000 }))
    const [token, setToken] = useState(null)
    // True once the chat socket is connected; client.user is set before that, so it can't be used as the signal.
    const [chatReady, setChatReady] = useState(false)
    useEffect( () => {
        if(currentUser && token){
            const connectUser = async () => {
                if (chatClient.user?.id !== "lamdahcom") {
                    await chatClient.connectUser({
                        id: "lamdahcom",
                        role: 'admin',
                        first_name: "Admin"
                    }, token)
                }
            }
            connectUser().then(() => {
                setChatReady(true)
            }).catch(error => {
                console.error("Could not connect to chat", error)
            });
        }
        return () => {

        }
    }, [currentUser, token])

    useEffect(()=>{
        axios({
            method: "get",
            withCredentials: true,
            url: `${SERVER}/auth/user`,
        }).then ( (res) => {
            setCurrentUser(res.data.user)
        }).catch(() => {
            // Not signed in; public pages work without a user.
        })
    }, [])

    const currentUserId = currentUser?._id
    useEffect(() => {
        if(currentUserId){
            axios({
                method: "get",
                withCredentials: true,
                url: `${SERVER}/stream/connect`,
            }).then ( (res) => {
                setToken(res.data.token)
            }).catch((err) => {
                console.error("Could not get a chat token", err)
            })
        }
    // Keyed on the id: re-fetching the same user creates a new object, which used to request a second token.
    }, [currentUserId]);

    function login(username, password) {
        return new Promise((resolve, reject) => {
            axios({
                method: "POST",
                data: {
                    identifier: username,
                    password: password,
                },
                withCredentials: true,
                url: `${SERVER}/auth/login`,
            }).then((res) => {
                setCurrentUser(res.data.user)
                resolve(res.data.user)
            }).catch(reject)
        })
    }
    async function getCurrentUser(){
        return new Promise((resolve, reject) => {
            axios({
                method: "get",
                withCredentials: true,
                url: `${SERVER}/auth/user`,
            }).then ( (res) => {
                setCurrentUser(res.data.user)
                resolve(res.data.user)
            }).catch(reject)
        })
    }

    function logout() {
        return new Promise((resolve, reject) => {
            axios({
                method: "get",
                withCredentials: true,
                url: `${SERVER}/auth/logout`,
            }).then ( (res) => {
                setCurrentUser(res.data.user)
                // Close the admin chat socket so it doesn't outlive the session in this tab.
                setToken(null)
                setChatReady(false)
                chatClient.disconnectUser().catch((err) => console.error("Could not disconnect chat", err))
                resolve();
            }).catch(err => {
                reject(err)
            })
        })
    }

    function changePassword(currentPassword, newPassword) {
        return new Promise((resolve, reject) => {
            axios({
                method: "POST",
                data: {
                    currentPassword: currentPassword,
                    newPassword: newPassword,
                },
                withCredentials: true,
                url: `${SERVER}/manager/changePassword`,
            }).then((res) => {
                resolve(res.data)
            }).catch((err) => {
                reject(err)
            })
        })
    }

    function changeUsername(password, newUsername) {
        return new Promise((resolve, reject) => {
            axios({
                method: "POST",
                data: {
                    password: password,
                    newUsername: newUsername,
                },
                withCredentials: true,
                url: `${SERVER}/manager/changeUsername`,
            }).then((res) => {
                if (res.data.success && res.data.username) {
                    // Update current user with new username
                    setCurrentUser(prev => ({
                        ...prev,
                        username: res.data.username
                    }));
                }
                resolve(res.data)
            }).catch((err) => {
                reject(err)
            })
        })
    }


    useEffect(() => {
        /*const unsubscribe = auth.onAuthStateChanged(user => {
            setCurrentUser(user)
            setLoading(false)
        })
*/
        //return unsubscribe
    }, [])

    const value = {
        currentUser,
        setCurrentUser,
        getCurrentUser,
        login,
        logout,
        changePassword,
        changeUsername,
        chatClient,
        chatReady
    }

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    )
}